<div class="fdx-c-modal fdx-c-overlay wlgn-overlay" *ngIf="show">
    <div class="fdx-c-modal__main  fdx-c-modal__main--medium" role="dialog">
        <div class="fdx-c-modal__footer">
            <button aria-label="Close" id="close_popup" 
                class="fdx-c-modal__footer__button fdx-c-button fdx-c-button--icon" (click)="showClosePopup('crossBtn')">
                <div>
                    <svg class="fdx-c-icon fdx-o-grid__item--9" aria-hidden="true" focusable="false"
                        role="presentation">
                        <use xlink:href="#cross"></use>
                    </svg>
                </div>
            </button>
        </div>
        <div class="fdx-c-modal__body">
            <div class="fdx-u-align--center">
                <div class="fdx-o-grid__row fdx-o-grid__row--center fdx-u-mt--8 fdx-u-mt--1@small fdx-u-pr--8@medium fdx-u-pl--8@medium">
                    <h1 class="fdx-c-header fdx-c-header--h4 fdx-u-pr--8@medium fdx-u-pl--8@medium"
                    id="singleDeleteTitle">
                    <span *ngIf="!deleteMultiple">
                        {{ 'removeTrustedDevice.title' | translate }}
                    </span>
                    <span *ngIf="deleteMultiple">
                        {{ 'removeTrustedDevice.titleAll' | translate }}
                    </span>
                    </h1>
                </div>
            </div>

            <div class="fdx-u-align--center">
                <div class="fdx-o-grid__row fdx-o-grid__row--center fdx-u-mt--8 fdx-u-mt--8@small">
                    <h4 class="fdx-c-header fdx-c-header--h7 fdx-u-pr--5@medium fdx-u-pl--5@medium"
                     id="singleDeleteNote">
                        {{ 'removeTrustedDevice.note' | translate }}
                    </h4>
                </div> 
            </div>
            <!-- Delete and cancel buttons -->
            <div class="fdx-c-button-group  fdx-c-button-group--gap fdx-c-button-group--stacked fdx-u-mt--8" role="group" aria-label="Filter group">
                <button aria-label="Remove" id="removeBtn" class="fdx-c-button fdx-c-button--primary" (click)="deleteDevice()">
                    {{ 'removeDevicePopup.removeButton' | translate }}
                </button>
                <a href="#" class="fdx-c-link-tiles__link">
                    <span aria-label="Close" id="cancelBtn" class="fdx-c-link-tiles__link__title" (click)="showClosePopup('cancelBtn')">
                        {{ 'removeDevicePopup.cancelButton' | translate }}
                    </span>
                </a>
            </div>
        </div>
    </div>
